import React from 'react';
import styles from './style.module.scss';
import GrayContainer from "../GrayContainer";
import TitleWithDashedLine from "../TitleWIthDashedLine"
import { Link } from "react-router-dom";

// const GAME_LINK = "https://gs3.geosense.tw:9555/gobacktochishang";
// const GAME_LINK = "https://drrstat2025.ncdr.nat.gov.tw/gobacktochishang";
const GAME_LINK = "https://drrstat.ncdr.nat.gov.tw/gobacktochishang";
// const GAME_LINK = "https://localhost/gobacktochishang";
const GAME_IMAGE = "/earthquake-page/homepage/0918game.png";

function GameCTASection() {
    return (
        <GrayContainer className={styles.grayContainer}>
            <div className={styles.wrapper}>
                <TitleWithDashedLine as="h3" text="假如地震當下你也在池上，讓AI預測你的地震應變力" />
                <a href={GAME_LINK} className={styles.card} target="_blank" rel="noopener noreferrer">        
                    <div className={styles.cover}>
                        <img src={GAME_IMAGE} alt="假如地震當下你也在池上，讓AI預測你的地震應變力" className={styles.coverImage} />
                    </div>             
                </a>
            </div>
        </GrayContainer>
    );
}

export default GameCTASection;